<template>
  <div>
        
    <el-card shadow="never" :body-style="{ padding: '20px' }" style=" width: 400px; ">
        <div slot="header" style="text-align: left;">
            <span>Carian</span>
        </div>
        <el-form :model="carian" ref="carian" label-width="90px" :inline="false" size="mini">
            <el-form-item label="Nama">
                    <el-input v-model="carian.nama" placeholder="" clearable></el-input>
            </el-form-item>
            <el-form-item label="Emel">
                    <el-input v-model="carian.email" placeholder="" clearable></el-input>
            </el-form-item>
            <el-form-item label="Telefon">
                    <el-input v-model="carian.tel" placeholder="" clearable></el-input>
            </el-form-item>
        </el-form>
    </el-card>
    
    <el-table :data="displayData"  stripe ref="tblSenarai" empty-text="Loading data.." style=" padding-top: 50px; margin-bottom: 20px;">            
        <el-table-column label="#" type="index" :index="pagination.page * pagination.pageSize - pagination.pageSize + 1" width="100"></el-table-column>
        <el-table-column prop="nama" label="Nama" width="400"></el-table-column>
        <el-table-column prop="email" label="Emel" width="250"></el-table-column>
        <el-table-column label="Telefon" width="150">
            <template slot-scope="x">
                <div v-if="x.row.tel != ''">
                    +{{ x.row.tel }}
                    <font-awesome-icon :icon="['fab', 'whatsapp']" size="lg" :style="{color: '#06a938'}" @click="openWhatsapp(x.row.tel)" style="cursor: pointer;"></font-awesome-icon>
                </div>
            </template>
        </el-table-column>
    </el-table>
    
    <el-pagination
    background
    layout="prev, pager, next"
    @current-change="currentChange"
    :page-size="pagination.pageSize"
    :total="pagination.total">
    </el-pagination>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
export default {
    name: 'DashboardDatabase',
    data() {
        return {
            senarai: [],
            pagination: {
                pageSize: 20,
                page: 1,
                total: 0
            },
            carian: {},
        }
    },
    computed: {
        isLoggedIn: function () { return this.$store.getters.isLoggedIn },
        stateWebID: function () { return this.$store.getters.stateWebID },
        displayData() {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.pagination.total = this.senarai.length
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            let data =  this.senarai
            
            //CARIAN
            if(this.carian.nama) {
                data = data.filter( user => user.nama.toLowerCase().search(this.carian.nama.toLowerCase()) != -1)
            }
            if(this.carian.tel) {
                data = data.filter( user => user.tel.toLowerCase().search(this.carian.tel.toLowerCase()) != -1 )
            }
            if(this.carian.email) {
                data = data.filter( user => user.email.toLowerCase().search(this.carian.email.toLowerCase()) != -1 )
            }

            return data.slice(this.pagination.pageSize * this.pagination.page - this.pagination.pageSize, this.pagination.pageSize * this.pagination.page);
        }
    },
    methods: {
        currentChange(val) {
            this.pagination.page = val
        },
        openWhatsapp(tel) {
            window.open('https://wa.me/' + tel)
        }
    },
    created() {   
        this.loading = true

        axios('/prospects').then( resp => {
            this.senarai = resp.data;
            this.loading = false
        })
    },
    filters: {
        bulan(x) {
            return moment(x,'yyyy-MM-DD hh:mm:ss').format('MMMM, yyyy')
        },
        tarikh(x) {
            return moment(x,'yyyy-MM-DD hh:mm:ss').format('DD/MM/yyyy')
        },
        formatMoney (v) {
            return v == null ? '0.00' : parseFloat(v).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');  // 12,345.67
        }
    }
}
</script>
